module.exports = __webpack_public_path__ + "img/profitOrange.7e8d2a61.png";